// extracted by mini-css-extract-plugin
export var alignCenter = "_bh-d";
export var bannerShown = "_bh-6";
export var buttonContent = "_bh-0";
export var cardList = "_bh-1";
export var centerContent = "_bh-2";
export var chevron = "_bh-3";
export var closePanelButton = "_bh-k";
export var conversationContextContainer = "_bh-l";
export var conversationDetailContainer = "_bh-4";
export var detailWrapper = "_bh-7";
export var dropdownButton = "_bh-e";
export var dropdownTitle = "_bh-9";
export var fullHeight = "_bh-5";
export var hidden = "_bh-a";
export var icon = "_bh-b";
export var mergeSuggestionWrapper = "_bh-m";
export var panel = "_bh-i";
export var portalButtonsWrapper = "_bh-c";
export var right = "_bh-j";
export var tableSummaryContainer = "_bh-8";
export var tableSummaryHeader = "_bh-g";
export var threeDotsButton = "_bh-f";
export var wide = "_bh-h";